import { render, staticRenderFns } from "./SocialPostCard.vue?vue&type=template&id=79d32040&scoped=true&"
import script from "./SocialPostCard.vue?vue&type=script&lang=js&"
export * from "./SocialPostCard.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostCard.vue?vue&type=style&index=0&id=79d32040&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d32040",
  null
  
)

export default component.exports